import { AccountLOB, AccountStatus, } from '@ally/data-types-afg-accounts';
import { getDomainData as getCustomizationDomainData } from '@ally/data-selectors-customization';
import { createSelector } from 'reselect';
import { getDomainData } from './selectors';
import { formatInvestAccountsForDropdown } from './utils';
/**
 * Returns all invest accounts or an empty array.
 */
var getAllInvestAccounts = createSelector(getDomainData, function (domain) { var _a, _b; return (_b = (_a = domain === null || domain === void 0 ? void 0 : domain.data) === null || _a === void 0 ? void 0 : _a.filter(function (account) {
    return [AccountLOB.INVEST, AccountLOB.WEALTH].includes(account.lob);
})) !== null && _b !== void 0 ? _b : []; });
/**
 * This selector utility returns a selector that takes getAllInvestAccounts as
 * its first selector and uses the combiner you pass to transform the afg account data
 */
var createInvestSelector = function (combiner) {
    return createSelector(getAllInvestAccounts, combiner);
};
var getOpenInvestAccounts = createInvestSelector(function (accounts) {
    return accounts.filter(function (_a) {
        var status = _a.status;
        return status !== AccountStatus.CLOSED;
    });
});
/**
 * Returns true/false whether any invest accounts have the `lastUpdated` property defined
 */
var getHasStaleAccounts = createInvestSelector(function (accounts) {
    return accounts.some(function (account) { return !!account.lastUpdated; });
});
var getInvestAccountsForDropdown = createSelector(getAllInvestAccounts, getCustomizationDomainData, function (investSummary, customizationDomain) {
    // istanbul ignore next
    if (investSummary === null)
        return [];
    return formatInvestAccountsForDropdown(investSummary, customizationDomain);
});
export default {
    getAll: getAllInvestAccounts,
    getAllForDropdown: getInvestAccountsForDropdown,
    getHasStaleAccounts: getHasStaleAccounts,
    getOpen: getOpenInvestAccounts,
};
//# sourceMappingURL=invest.js.map